import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Location} from '@/schemas/sub-schemas';
import {SportLocation} from '@/types/sportLocation';

export interface LocationCreateFormState {
  title: string;
  description: string;
  location: Location | null;
  sports: string | string[] | null;
  picture: string | null;
}

interface LocationState {
  myLocations: SportLocation[];
  locationCreateForm: LocationCreateFormState;
}

export const initialState: LocationState = {
  myLocations: [],
  locationCreateForm: {
    title: '',
    description: '',
    location: null,
    sports: [],
    picture: null
  }
};

const locationSlice = createSlice({
  name: 'location',
  initialState: initialState,
  reducers: {
    setLocationFormData(
      state,
      action: PayloadAction<Partial<LocationCreateFormState>>
    ) {
      state.locationCreateForm = {
        ...state.locationCreateForm,
        ...action.payload
      };
    },

    resetLocationFormData(state) {
      state.locationCreateForm = {
        ...initialState.locationCreateForm
      };
    }
  }
});

export const {setLocationFormData, resetLocationFormData} =
  locationSlice.actions;
export default locationSlice.reducer;
